import request from '@/utils/httpClient'

// 查找行政编号下的子节点行政地区，最小值为0
export function getListByNo(superId: number, params?: object) {
  return request({
    url: `location/list/${superId}`,
    method: 'get',
    params
  })
}

export function batchCreate(data: object) {
  return request({
    url: 'location/batch',
    method: 'post',
    data
  })
}
